/* PREAMATO image viewer: a click or tap on the photo closes it, and the photo can be swiped to the next / previous photo.
   - click (mouse) or tap (touch screen) on the photo = close the viewer
   - drag or swipe sideways with the mouse = next / previous (drag left for next)
   - two finger swipe sideways on a trackpad = next / previous
   - two finger click on a trackpad (a secondary click) or a two finger tap on a touch screen = close the viewer too
   - touch screens keep the viewer's own swipe
   (Earlier version: a click on the left / right half of the photo went to the previous / next photo. Replaced by click to close.)
   The viewer (PhotoSwipe) listens to the arrow keys and Escape, so each of these is turned into a key press.
   Needs no changes to the theme's own script. */
(function () {
  if (window.__paLightboxLink) return;
  window.__paLightboxLink = true;

  var SWIPE_DISTANCE = 40;
  var WHEEL_DISTANCE = 30;
  var WHEEL_PAUSE = 700;
  var TAP_TIME = 350;
  var TAP_MOVE = 20;

  var tracking = false;
  var startX = 0;
  var startY = 0;
  var lastWheel = 0;

  function viewerOpen() {
    return !!document.querySelector('.pswp--open');
  }

  function inViewer(event) {
    return !!(event.target && event.target.closest && event.target.closest('.pswp--open'));
  }

  function onViewerPhoto(event) {
    return !!(event.target && event.target.closest && event.target.closest('.pswp--open .pswp__img'));
  }

  function press(key, code) {
    var init = { key: key, code: key, keyCode: code, which: code, bubbles: true, cancelable: true };
    document.dispatchEvent(new KeyboardEvent('keydown', init));
  }

  function next() {
    press('ArrowRight', 39);
  }

  function previous() {
    press('ArrowLeft', 37);
  }

  function close() {
    press('Escape', 27);
  }

  /* the browser must not start its own drag-and-drop of the picture (that cancels the mouse press and ends the swipe) */
  document.addEventListener('dragstart', function (event) {
    if (onViewerPhoto(event)) event.preventDefault();
  }, true);

  /* the viewer's own mouse handling (zoom on click, drag to pan) is switched off for the photo; it is replaced below */
  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType === 'mouse' && event.button === 0 && onViewerPhoto(event)) {
      tracking = true;
      startX = event.clientX;
      startY = event.clientY;
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  function finish(event) {
    if (!tracking) return;
    tracking = false;
    event.stopPropagation();

    var dx = event.clientX - startX;
    var dy = event.clientY - startY;

    if (Math.abs(dx) > SWIPE_DISTANCE && Math.abs(dx) > Math.abs(dy)) {
      /* swipe: dragging left moves on to the next photo */
      if (dx < 0) {
        next();
      } else {
        previous();
      }
    } else if (Math.abs(dx) <= SWIPE_DISTANCE && Math.abs(dy) <= SWIPE_DISTANCE && onViewerPhoto(event)) {
      /* click without dragging: close the viewer */
      close();
    }
  }

  document.addEventListener('pointerup', finish, true);

  /* if the browser cancels the press anyway, the swipe is still read from the last position seen */
  var lastX = 0;
  var lastY = 0;

  document.addEventListener('pointermove', function (event) {
    if (tracking) {
      lastX = event.clientX;
      lastY = event.clientY;
    }
  }, true);

  document.addEventListener('pointercancel', function (event) {
    if (!tracking) return;
    finish({ clientX: lastX || startX, clientY: lastY || startY, target: null, stopPropagation: function () {} });
  }, true);

  /* the click that follows a mouse press is swallowed so the viewer does not zoom; a tap on a touch screen closes the viewer */
  document.addEventListener('click', function (event) {
    if (!onViewerPhoto(event)) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.pointerType === 'touch') close();
  }, true);

  /* two finger swipe sideways on a trackpad (one move per swipe) */
  document.addEventListener('wheel', function (event) {
    if (!viewerOpen()) return;
    if (Math.abs(event.deltaX) <= Math.abs(event.deltaY) || Math.abs(event.deltaX) < WHEEL_DISTANCE / 3) return;

    event.preventDefault();
    event.stopPropagation();

    var now = Date.now();
    if (now - lastWheel < WHEEL_PAUSE || Math.abs(event.deltaX) < WHEEL_DISTANCE) return;
    lastWheel = now;

    if (event.deltaX > 0) {
      next();
    } else {
      previous();
    }
  }, { capture: true, passive: false });

  /* two finger click on a trackpad is a secondary click: it closes the viewer instead of opening the browser menu */
  document.addEventListener('contextmenu', function (event) {
    if (!inViewer(event)) return;
    event.preventDefault();
    event.stopPropagation();
    close();
  }, true);

  /* two finger tap on a touch screen: two fingers down and up quickly without moving closes the viewer */
  var twoStart = 0;
  var twoPoints = null;
  var twoMoved = false;

  document.addEventListener('touchstart', function (event) {
    if (!inViewer(event)) return;
    if (event.touches.length === 2) {
      twoStart = Date.now();
      twoMoved = false;
      twoPoints = [
        { x: event.touches[0].clientX, y: event.touches[0].clientY },
        { x: event.touches[1].clientX, y: event.touches[1].clientY }
      ];
    } else if (event.touches.length > 2) {
      twoStart = 0;
    }
  }, { capture: true, passive: true });

  document.addEventListener('touchmove', function (event) {
    if (!twoStart || !twoPoints || event.touches.length !== 2) return;
    for (var i = 0; i < 2; i++) {
      if (Math.abs(event.touches[i].clientX - twoPoints[i].x) > TAP_MOVE || Math.abs(event.touches[i].clientY - twoPoints[i].y) > TAP_MOVE) {
        twoMoved = true;
      }
    }
  }, { capture: true, passive: true });

  document.addEventListener('touchend', function (event) {
    if (!twoStart) return;
    if (event.touches.length === 0 || event.touches.length === 1) {
      var quick = Date.now() - twoStart < TAP_TIME;
      var still = !twoMoved;
      twoStart = 0;
      twoPoints = null;
      if (quick && still && viewerOpen()) close();
    }
  }, { capture: true, passive: true });
})();
